<template>
  <div
    class="tab-bar"
    :style="{
      background: bgColor
    }"
  >
    <div
      class="inner"
      :style="{
        width: `${width}px`
      }"
    >
      <div
        class="tab-item"
        v-for="item in tabList"
        :key="item.value"
        :class="{current: item.value === value}"
        @click="onTabClick(item)"
      >
        {{ item.label }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    tabList: {
      type: Array,
      default: () => []
    },
    width: {
      type: Number,
      default: 1200
    },
    bgColor: {
      type: String,
      default: "linear-gradient(90deg, #2B77DF 0%, #3299F0 100%)"
    },
    value: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      current: ""
    };
  },
  methods: {
    onTabClick(data) {
      if (data.value === this.value) {
        return;
      }
      this.$emit("input", data.value);
      this.$emit("change", data);
    }
  }
};
</script>

<style scoped lang="scss">
.tab-bar {
  width: 100%;
  height: 46px;
  text-align: center;
  .inner {
    height: 100%;
    display: inline-flex;
    .tab-item {
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #fefefe;
      font-size: 18px;
      padding: 0 23px;
      height: 100%;
      &.current {
        background: #1063d7;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/tabBar/index.vue